import { apiService } from './api.service';
import { ENDPOINTS } from '../config/api';
import { Course, UWSubject, UWCourse, UWClassSchedule } from '../types';

class CourseService {
  async getCourses(search?: string): Promise<Course[]> {
    const params = search ? { search } : {};
    return apiService.get<Course[]>(ENDPOINTS.COURSES, { params });
  }

  async getCourseByCode(code: string): Promise<Course> {
    return apiService.get<Course>(ENDPOINTS.COURSE_DETAIL(code));
  }

  async syncCourses(): Promise<{ message: string }> {
    return apiService.post(ENDPOINTS.SYNC_COURSES);
  }

  async lookupCourse(code: string): Promise<Course> {
    return apiService.post<Course>(ENDPOINTS.COURSE_LOOKUP, { code });
  }

  async getSubjects(): Promise<UWSubject[]> {
    return apiService.get<UWSubject[]>(`${ENDPOINTS.COURSES}subjects`);
  }

  async getUWCourses(subject: string): Promise<UWCourse[]> {
    return apiService.get<UWCourse[]>(`${ENDPOINTS.COURSES}uw/${subject}`);
  }

  async getUWCourseDetail(subject: string, catalogNumber: string): Promise<UWCourse[]> {
    return apiService.get<UWCourse[]>(`${ENDPOINTS.COURSES}uw/${subject}/${catalogNumber}`);
  }

  async getUWCourseSchedule(subject: string, catalogNumber: string): Promise<UWClassSchedule[]> {
    return apiService.get<UWClassSchedule[]>(`${ENDPOINTS.COURSES}uw/${subject}/${catalogNumber}/schedule`);
  }
}

export const courseService = new CourseService();
